<template>
  <div>
    <div class="form-row">
      <div class="form-group col-6">
        <label 
          class="required"
          style="margin-top: 1em;"
        >
          {{ $t('resource.format.label') }}
        </label>
        <p>{{ $t('resource.format.help') }}</p>
        <ValidatedFileFormatSelector
          :required="resource.isNotEmpty()"
          :validation-name="`Format ${isMain ? 'resource' : 'annexe'}`"
          @select="selectFormat($event)"
        />
        <p style="margin-top: 0.5em; font-size: 0.85em; white-space: wrap;">
          {{ $t('resource.fileUpload.formatHelp') }}
        </p>
      </div>
      <div class="col-1" />
      <div class="form-group col-5">
        <label>
          {{ $t('resource.fileUpload.file.label') }}
        </label>
        <p>{{ $t('resource.fileUpload.file.help') }}</p>
        <ImportFile
          :key="`${isMain ? 'resource' : 'annexe'}-import-file`"
          :name="isMain ? 'resource' : 'annexe'"
          :accept="form.format ?
            resourceDataFormats
              .find(el => el.codename === form.format.codename).extension
              .map(el => { return `.${el}` }).join(',') :
            ''
          "
          :disabled="!(form.format && form.format.codename)"
          :required="resource.isNotEmpty()"
          @update="setResourceFile"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { getCSVFileHeaders } from '@/utils/csv.js';
import ValidatedFileFormatSelector from '@/common/components/ValidatedFileFormatSelector.vue';
import ImportFile from '@/components/ImportFile.vue';

export default {
  name: 'FileUploadCreator',

  components: {
    ImportFile,
    ValidatedFileFormatSelector,
  },

  props: {
    required: {
      type: Boolean,
      default: true
    },
    resource: {
      type: Object,
      default: () => ({})
    },
    isMain: {
      type: Boolean,
      default: true
    },
  },

  data() {
    return {
      form: {
        type: 'file-upload',
        format: null,
        file: null
      },
    };
  },

  computed: {
    ...mapState('resources', [
      'resourceDataFormats',
    ]),
  },

  watch: {
     
  },

  created() {
    if (!this.resource) this.resource = {};
    this.$set(this.resource, 'type', 'file-upload');
    if (!this.resource.fileupload) {
      this.$set(this.resource, 'fileupload', {});
    }
  },

  methods: {
    selectFormat(format) {
      this.form.format = format;
      this.$set(this.resource.fileupload, 'dataformat', format.codename);
    },
    setResourceFile(e) {
      this.resource.file = e;
      const file = e;
      getCSVFileHeaders(file).then((header)=>{
        this.$set(this.resource, 'xyColumnsOptions', header);
      });
    
    }
  }
};
</script>
